// =============================================================================
// state
// =============================================================================
const state = {
  loginToken: null,
  userName: '',
};
// =============================================================================
// getters
// =============================================================================
const getters = {
  login_token: state => state.loginToken,
  user_name: state => state.userName,
};
// =============================================================================
// actions
// =============================================================================
const actions = {
};
// =============================================================================
// mutations
// =============================================================================
const mutations = {
  set_data (state, value) {
    state.loginToken = value.token;
    state.userName = value.user_name;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
